function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.907,6.487l-36.29,41.09C6.285,47.878,5.907,48,5.497,48c-0.35,0-0.717-0.043-0.997-0.293c-0.62-0.55-0.673-1.5-0.123-2.12l5.94-6.72l1.68-1.91c1.04-0.23,1.983-1.12,2.083-2.21l1.557-1.91l25.02-28.33c0.55-0.62,1.5-0.68,2.12-0.13C43.397,4.917,43.457,5.867,42.907,6.487z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M3 38L3 35 8 35M9.449 31.654L39.069 3.462C41.569 1.562 45 4.762 45 12c0 10-12.008 9-12.008 19"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "bevel",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M15 27L19 31M26.607 15.607L28.995 17.995M37.977 4.977L39.271 6.271"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5,30C9.019,30,7,32.019,7,34.5S9.019,39,11.5,39s4.5-2.019,4.5-4.5S13.981,30,11.5,30z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M31.219,45.911C31.55,46.557,32.223,47,33,47c1.105,0,2-0.895,2-2s-0.895-2-2-2v-3.982"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.919 34c-.372-2.279-1.987-4-3.919-4s-3.547 1.721-3.919 4H36.919zM29.081 36c.372 2.279 1.987 4 3.919 4s3.547-1.721 3.919-4H29.081z"
});

function SvgFishing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishing);
export default __webpack_public_path__ + "static/media/fishing.5180bef0.svg";
export { ForwardRef as ReactComponent };